import { render, staticRenderFns } from "./QualityInspectionStandard.vue?vue&type=template&id=8d182f1c&scoped=true&"
import script from "./QualityInspectionStandard.vue?vue&type=script&lang=js&"
export * from "./QualityInspectionStandard.vue?vue&type=script&lang=js&"
import style0 from "./QualityInspectionStandard.vue?vue&type=style&index=0&id=8d182f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d182f1c",
  null
  
)

export default component.exports